import React from 'react';
import { Card, CardContent, Typography, useTheme, Box } from '@mui/material';
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  ResponsiveContainer,
} from 'recharts';

const data = [
  { date: 'Mon', revenue: 4000, netIncome: 1200 },
  { date: 'Tue', revenue: 5000, netIncome: 2100 },
  { date: 'Wed', revenue: 4500, netIncome: 1500 },
  { date: 'Thu', revenue: 6000, netIncome: 2400 },
  { date: 'Fri', revenue: 5200, netIncome: 2000 },
  { date: 'Sat', revenue: 6800, netIncome: 2700 },
  { date: 'Sun', revenue: 9200, netIncome: 3000 },
];

const SalesCard = () => {
  const theme = useTheme();

  return (
    <Card
      sx={{
        height: '100%',
        borderRadius: 3,
        overflow: 'hidden',
        display: 'flex',
        flexDirection: 'column',
        p: 2,
        backgroundColor: '#fff',
        color: theme.palette.text.primary,
        boxShadow: '0 8px 16px rgba(0,0,0,0.1)',
        transition: 'transform 0.3s ease',
        '&:hover': {
          transform: 'scale(1.01)',
          boxShadow: '0 12px 24px rgba(0,0,0,0.15)',
        },
      }}
    >
      <CardContent sx={{ p: 0 }}>
        <Typography variant="h6" sx={{ fontWeight: 600 }}>
          Sales Summary
        </Typography>
        <Typography variant="h4" sx={{ fontWeight: 700 }}>
          $38,760
        </Typography>
        <Typography variant="body2" sx={{ opacity: 0.8 }}>
          Revenue vs Net Income (This Week)
        </Typography>
      </CardContent>

      {/* 🔁 Responsive Chart Container */}
      <Box sx={{ flexGrow: 1, mt: 2, minHeight: 250 }}>
        <ResponsiveContainer width="100%" height="100%">
          <BarChart
            data={data}
            margin={{ top: 0, right: 20, left: 10, bottom: 10 }}
            barGap={6}
          >
            <CartesianGrid
              strokeDasharray="3 3"
              stroke={theme.palette.grey[300]}
              opacity={0.4}
            />
            <XAxis
              dataKey="date"
              stroke={theme.palette.grey[600]}
              tick={{ fontSize: 12 }}
              axisLine={false}
              tickLine={false}
            />
            <YAxis
              stroke={theme.palette.grey[600]}
              tick={{ fontSize: 12 }}
              axisLine={false}
              tickLine={false}
              domain={[0, 10000]}
              ticks={[0, 2000, 4000, 6000, 8000, 10000]}
            />
            <Tooltip
              formatter={(value, name) => [`$${value.toLocaleString()}`, name === 'revenue' ? 'Revenue' : 'Net Income']}
              contentStyle={{
                background: theme.palette.background.paper,
                color: theme.palette.text.primary,
                borderRadius: 4,
                boxShadow: '0px 4px 12px rgba(0,0,0,0.1)',
              }}
              labelStyle={{ fontWeight: 600 }}
              itemStyle={{ color: theme.palette.text.secondary }}
            />
            <Legend verticalAlign="top" height={36} />
            <Bar
              dataKey="revenue"
              fill={theme.palette.primary.main}
              radius={[4, 4, 0, 0]}
              barSize={20}
            />
            <Bar
              dataKey="netIncome"
              fill={theme.palette.secondary.main}
              radius={[4, 4, 0, 0]}
              barSize={20}
            />
          </BarChart>
        </ResponsiveContainer>
      </Box>
    </Card>
  );
};

export default SalesCard;
